export enum SCAN_TYPE {
  POSTURE = 'posture',
  SPINE = 'spine',
}
